import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-resource-card',
  templateUrl: './resource-card.html',
  styleUrl: './resource-card.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.selected]': 'selected()',
    '[class.disabled]': 'disabled()',
    '[attr.tabindex]': 'disabled() ? -1 : 0',
    '[attr.role]': '"button"',
    '[attr.aria-label]': 'ariaLabel()',
    '(click)': '!disabled() && cardClick.emit()',
    // Keyboard is a separate output so parents that debounce mouse clicks
    // (documents / assessment) can open the drawer immediately on Enter /
    // Space without waiting on the click timer.
    '(keydown.enter)': '!disabled() && cardActivate.emit()',
    '(keydown.space)': '$event.preventDefault(); !disabled() && cardActivate.emit()',
  },
})
export class ResourceCardComponent {
  selected = input(false);
  disabled = input(false);
  ariaLabel = input('');

  /** Mouse click on the card. */
  cardClick = output<void>();
  /** Enter / Space — prefer immediate activation (no click debounce). */
  cardActivate = output<void>();
}
